<div class="page-container">
  <header>
    <h1>{{ 'team-list.title' | translate }}</h1>
  </header>

  <main class="content-area">
    
    <!-- LOADING -->
    @if (isLoading()) {
      <div class="loading-state">
        <div class="spinner"></div>
      </div>
    }

    <!-- CONTENT -->
    @if (!isLoading()) {
      
      @if (groupedTeams().length > 0) {
        <div class="groups-container">
          
          @for (group of groupedTeams(); track group.name) {
            <section class="org-group">
              <h2 class="org-title">{{ group.name }}</h2>
              
              <div class="teams-grid">
                @for (team of group.teams; track team.id) {
                  <!-- 
                    Link to /teamRecordings/{id} 
                    This generates a standard <a href> tag
                  -->
                  <a [routerLink]="['/teamRecordings', team.id]" class="team-card">
                    <div class="card-content">
                      <span class="team-initial">{{ team.name.charAt(0) }}</span>
                      <span class="team-name">{{ team.name }}</span>
                    </div>
                    <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
                    </svg>
                  </a>
                }
              </div>
            </section>
          }

        </div>
      } @else {
        <div class="empty-state">
          <p>{{ 'team-list.no-teams' | translate }}</p>
        </div>
      }

    }
  </main>
</div>